angular.module('impactx.invoice').controller('InvoiceMatchListCtrl', [
    'selectedListItems',
    '$mdDialog',
    '$routeParams',
    'BackService',
    'dataGen',
    'ToastService',
    '$redirect',
    InvoiceMatchListCtrl
]);

function InvoiceMatchListCtrl(selectedListItems, $mdDialog, $routeParams, BackService, dataGen, ToastService, $redirect) {
    var self = this;

    self.blhId = $routeParams.id;

    var buttonDefinition = [
        {
            label: 'match',
            action: doMatch,
            condition: selectedListItems.isMultiSelection
        }
    ];

    function doMatch() {
        // No more comments dialog
        dataGen.postAsForm({}, {blhId: self.blhId, dnhIds: selectedListItems.getSelectedIds()}, "/invoice/match/deliverynote").then(function (data) {
            ToastService.openStandardToast(data.trns.matchSuccess);
            $redirect.redirectTo(null, '/custominvoiceview/' + self.blhId);
        });
    }

    self.meta = {
        rowTemplate: 'modules/invoice/templates/invoicematchlist.row.html',
        isSelectAble: true,
        ctrl: self,
        endpoint: '/invoice/match/deliverynote/select',
        id: "InvoiceMatchList",
        excelExport: false,
        buttonDefinition: buttonDefinition,
        valuesInteger: [{name: 'blhId', value: self.blhId}],
    };
    self.getMeta = function () {
        return self.meta;
    };
}